import { PartnerOpportunitiesView } from "@/components/partner/PartnerViews";

const PartnerOpportunities = () => <PartnerOpportunitiesView />;

export default PartnerOpportunities;
